import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SliderModule} from 'primeng/slider';
import { DropdownModule} from 'primeng/dropdown';
import { MultiSelectModule} from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
// import { PublicUserComponent } from '../public-user/public-user.component';
import {CalendarModule} from 'primeng/calendar'
import { TooltipModule } from 'primeng';
import {ToastModule} from 'primeng/toast';

@NgModule({
  imports: [
    CommonModule,
    HomeRoutingModule,
    FormsModule,
    PaginatorModule,
    ReactiveFormsModule,
    TableModule,
    SliderModule,
    DropdownModule,
    MultiSelectModule,
    CalendarModule,
    TooltipModule,
    ToastModule,
  ],
  declarations: [HomeComponent],
  providers: []
})

export class HomeModule { }
